const workflow = {
  title: "Workflow",
  description: "Crie e gerencie workflows para seus workspaces",
  nodesPalette: "Paleta de Nodes",
  savedSuccessfully: "Workflow salvo com sucesso",
  createNode: "Criar Node",
  test: {
    completed: "Workflow concluído",
    completedDescription: "O workflow foi executado com sucesso.",
    start: 'Iniciar Teste',
    stop: 'Parar Teste',
    pause: 'Pausar',
    resume: 'Continuar',
    stopped: 'Teste de workflow parado com sucesso',
    stopped_error: 'Erro ao parar o teste de workflow',
    paused: 'Teste de workflow pausado',
    paused_error: 'Erro ao pausar o teste de workflow',
    resumed: 'Teste de workflow retomado',
    resumed_error: 'Erro ao retomar o teste de workflow',
    webhook_timeout: 'Tempo esgotado aguardando webhook',
    no_nodes: 'Adicione ao menos um nó ao seu workflow antes de testá-lo',
    error: 'Erro ao executar o workflow',
    success: 'Workflow executado com sucesso',
    running: 'Executando workflow...',
    start_button: "Testar Workflow",
    testing: "Testando...",
    success_title: "Teste concluído",
    success_description: "O teste do workflow foi concluído com sucesso",
    error_title: "Erro no teste",
    error_description: "Ocorreu um erro durante o teste: {{error}}",
    start_error: "Erro ao iniciar o teste: {{error}}",
    trigger_timeout_title: "Timeout no trigger",
    trigger_timeout_description: "O tempo de espera pelo trigger expirou",
    webhook_received_title: "Webhook recebido",
    webhook_received_description: "O webhook foi recebido com sucesso e o fluxo vai continuar",
    copied_to_clipboard: "URL copiada para a área de transferência"
  },
  webhook: {
    title: "URL do Webhook (Frontend)",
    public: "Público",
    copyUrl: "Copiar URL",
    copied: "Copiado!",
    open: "Abrir",
    proxyInfo: "Esta URL usa o proxy do frontend para encaminhar requisições para o backend com segurança.",
    usageInfo: "Configure esta URL em ferramentas externas como Jira, Azure DevOps, Confluence, etc.",
    waiting_title: 'Aguardando Webhook',
    waiting_message: 'Aguardando resposta do webhook. Tempo restante:',
    waiting_message_simple: 'Aguarde enquanto o webhook está sendo processado',
    url: 'URL do Webhook',
    url_help: 'Use esta URL para enviar dados para o webhook',
    copy_url: 'URL do webhook copiada para a área de transferência',
    copy_error: 'Erro ao copiar URL do webhook',
    error: {
      timeout: 'Tempo esgotado aguardando resposta do webhook'
    },
    confirm_stop_title: 'Parar Workflow?',
    confirm_stop_description: 'Fechar esta janela irá parar o workflow em execução. Deseja continuar?',
    stop_workflow: 'Parar Workflow',
    filter: {
      title: 'Filtros de Webhook',
      conditions: {
        add: 'Adicionar Condição'
      },
      description: 'Configure filtros para processar dados do webhook',
      addFilter: 'Adicionar Filtro',
      addArrayFilter: 'Adicionar Filtro de Array',
      removeFilter: 'Remover Filtro',
      path: 'Caminho',
      pathPlaceholder: 'ex: user.name',
      operation: 'Operação',
      value: 'Valor',
      valuePlaceholder: 'Digite o valor',
      dataType: 'Tipo de Dados',
      arrayPath: 'Caminho do Array',
      arrayPathPlaceholder: 'Propriedade dentro do array',
      arrayOperation: 'Operação do Array',
      nestedFilters: 'Filtros Aninhados',
      operations: {
        equals: 'Igual a',
        contains: 'Contém',
        startsWith: 'Começa com',
        endsWith: 'Termina com',
        greaterThan: 'Maior que',
        lessThan: 'Menor que',
        exists: 'Existe',
        notExists: 'Não existe'
      },
      arrayOperations: {
        some: 'Alguns (pelo menos um)',
        every: 'Todos',
        none: 'Nenhum'
      },
      filterTitle: 'Filtro {{index}}',
      arrayFilterTitle: 'Filtro de Array {{index}}',
      conditionTitle: 'Condição {{index}}',
      cardTitle: 'Filtro de Dados',
      cardDescription: 'Defina condições para filtrar os dados recebidos. Apenas dados que atendam essas condições serão processados pelo fluxo de trabalho.'
    }
  },
  error: {
    save_connection: "Erro ao salvar conexão",
    save_schema: "Erro ao salvar schema",
    webhook_registration_failed: "Falha ao registrar webhook",
    server_error: "Erro no servidor",
    test_failed: "Falha no teste",
    unknown: "Erro desconhecido",
    no_webhook_trigger: "Nenhum trigger de webhook",
    no_webhook_trigger_desc: "O workflow precisa ter um node do tipo webhook_trigger para ser testado"
  },
  nodeExecutedSuccessfully: "Node executado com sucesso",
  nodeSavedSuccessfully: "Configuração do node salva com sucesso",
  nodes: {
    common: {
      input: "Entrada",
      output: "Saída",
      conditions: "Condições",
      defaultOutput: "Saída padrão",
      noInputYet: "Sem entrada ainda!",
      noOutputYet: "Sem saída ainda!",
      runNodeToSeeOutput: "Execute este node para ver a saída",
      runPreviousNodeToSeeInput: "Execute o node anterior para ver a entrada"
    },
    rag_assistant: {
      title: "Assistente RAG",
      description: "Gere respostas usando RAG (Retrieval-Augmented Generation)",
      response_format: {
        label: "Formato de Resposta",
        description: "Escolha o formato de saída para a resposta da LLM",
        placeholder: "Selecione o formato de resposta",
        options: {
          text: "Texto",
          json_schema: "JSON Schema",
          json_object: "Objeto JSON"
        }
      },
      json_schema: {
        label: "Schema JSON",
        description: "Defina a estrutura do schema JSON que a LLM deve seguir ao retornar uma resposta",
        placeholder: "{\n  \"type\": \"object\",\n  \"properties\": {\n    \"campo\": { \"type\": \"string\" }\n  }\n}"
      },
      errors: {
        json_schema_required: "Schema JSON é obrigatório quando Formato de Resposta é 'json_schema'",
        invalid_json: "Formato JSON inválido",
        schema_must_be_object: "Schema JSON deve ser um objeto",
        schema_missing_type: "Schema JSON deve ter uma propriedade 'type'"
      }
    },
    if_then: {
      title: "Se...então",
      description: "Execute diferentes caminhos baseados em uma condição",
      conditions: {
        list: "Lista de condições para avaliar",
        value: "Valor",
        operator: "Operador",
        compareValue: "Comparar Valor",
        valueToEvaluate: "Valor para avaliar",
        valueToCompareAgainst: "Valor para comparar",
        combineWithNext: "Combinar com próxima condição",
        howToCombine: "Como combinar com a próxima condição",
        addItem: "Adicionar condição",
        selectOperator: "Selecionar operador",
        selectCombine: "Selecionar combinação"
      },
      operators: {
        equals: "Igual a",
        notEquals: "Diferente de",
        greaterThan: "Maior que",
        lessThan: "Menor que",
        greaterThanOrEqual: "Maior ou igual a",
        lessThanOrEqual: "Menor ou igual a",
        contains: "Contém",
        notContains: "Não contém",
        startsWith: "Começa com",
        endsWith: "Termina com",
        empty: "Vazio",
        notEmpty: "Não vazio"
      },
      combiners: {
        and: "E",
        or: "OU"
      },
      defaultOutput: "Saída quando nenhuma condição corresponder (else)"
    }
  },
  edge: {
    deleteSuccess: "Sucesso",
    deleteSuccessDescription: "Conexão removida com sucesso",
    deleteError: "Erro",
    deleteErrorDescription: "Erro ao remover a conexão"
  },
  schedule: {
    executed: "Agendamento Executado",
    executedDescription: "O workflow foi executado no horário agendado.",
    active: "Agendamento Ativo",
    nextExecution: "Próxima Execução Em:",
    config: "Configuração do Agendamento",
    expression: "Expressão:",
    timezone: "Timezone:",
    autoExecute: "O workflow será executado automaticamente no horário agendado.",
    stop: "Parar Workflow",
    stopConfirm: "Tem certeza de que deseja parar a execução do workflow? O agendamento será cancelado."
  },
  nodeConfig: {
    validationError: "Erro de validação",
    validationErrorDescription: "Verifique os campos do formulário"
  },
  email: {
    contentLabel: "Conteúdo do Email",
    customHtml: "HTML Personalizado",
    loadingTemplates: "Carregando...",
    selectTemplate: "Selecione um template",
    noTemplate: "— Nenhum —",
    customBadge: "customizado",
    noTranslation: "Este template não possui tradução disponível.",
    subjectOverrideLabel: "Assunto (opcional — sobrescreve o assunto do template)",
    keepOriginalSubject: "Manter assunto original do template",
    mapVariables: "Mapear variáveis do template",
    variable: "Variável",
    value: "Valor",
    workflowField: "Campo do workflow",
    freeValuePlaceholder: "Valor livre ou {{input.*}}",
    notMapped: "— não mapeado —",
    noInputFields: "sem campos de entrada",
    useWorkflowField: "Usar campo do workflow",
    typeManually: "Digitar valor manualmente",
    templateDetails: "Detalhes do template",
    originalSubject: "Assunto original: ",
    preview: "Pré-visualizar",
    previewTitle: "Preview: {{name}}",
    subject: "Assunto",
    subjectPlaceholder: "Assunto do email. Suporta {{input.*}}",
    bodyHtml: "Corpo (HTML)",
    hidePreview: "Ocultar preview",
    nothingToPreview: "Nada para visualizar",
    autoFilledVariables: "Variáveis preenchidas automaticamente pelo workflow:",
    key: "Chave",
    description: "Descrição",
    example: "Exemplo",
    dynamicLanguageLabel: "Idioma (placeholder)",
    useFixedLanguage: "Voltar para seleção fixa",
    useDynamicLanguage: "Usar placeholder dinâmico"
  }
} as const;

export default workflow;
